import { createDraggable } from "animejs";

export default ({
    target,
    enabled = true,
    options,
    initialState = { x: null, y: null },
    onDrag = () => null,
    onRelease = () => null,
    onResize = () => null,
    onAfterResize = () => null,
    onUpdate = () => null,
    init = () => {},
    ...others
} = {}) => ({
    ...others,
    enabled: enabled,
    draggable: null,
    startDraggable() {
        this.$nextTick(() => {
            this.draggable = createDraggable(target, {
                y: false,
                cursor: {
                    onHover: "col-resize",
                    onGrab: "col-resize",
                },
                onDrag: (draggable) => {
                    onDrag.call(this, draggable);
                },
                onRelease: (draggable) => onRelease.call(this, draggable),
                onResize: (draggable) => onResize.call(this, draggable),
                onAfterResize: (draggable) => onAfterResize.call(this, draggable),
                onUpdate: (draggable) => onUpdate.call(this, draggable),
                ...options,
            });

            if (initialState.x) {
                this.draggable.setX(initialState.x);
            }

            if (initialState.y) {
                this.draggable.setY(initialState.y);
            }
        });
    },
    init() {
        if (this.enabled) {
            this.startDraggable();
        }

        this.$watch("enabled", (value) => {
            if (value) {
                this.startDraggable();
            } else {
                this.destroy();
            }
        });

        init.call(this);
    },
    destroyDraggable() {
        if (this.draggable) {
            this.draggable.revert();
            this.draggable = null;
        }
    },
    destroy() {
        this.destroyDraggable();
    },
});
